import React from 'react'
import { Field, ErrorMessage, useFormikContext } from 'formik'
import { CenterApplicationFormType } from '../../../types'

export const CenterComponentsForm: React.FC = () => {
  const { values } = useFormikContext<CenterApplicationFormType>()

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
        <h3 className="text-2xl leading-6 font-bold text-[#3C2416]">
          Center Components & Capabilities
        </h3>
        <p className="mt-2 text-sm text-[#142841]">
          Please provide information about your center&apos;s physical space,
          patient capacity, and clinical capabilities.
        </p>
      </div>

      <div className="px-4 py-5 sm:px-6 space-y-8">
        {/* Patient Numbers Section */}
        <div>
          <h4 className="text-lg font-semibold text-[#3C2416] mb-4">
            Patient Population
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {(values.centerType === 'adult' ||
              values.centerType === 'whole_life') && (
              <>
                <div>
                  <label
                    htmlFor="numberOfAdultSca"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Adult SCA Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfAdultSca"
                    id="numberOfAdultSca"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfAdultSca"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>

                <div>
                  <label
                    htmlFor="numberOfAdultSc"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Adult SC Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfAdultSc"
                    id="numberOfAdultSc"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfAdultSc"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>

                <div>
                  <label
                    htmlFor="numberOfAdultOther"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Other Adult Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfAdultOther"
                    id="numberOfAdultOther"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfAdultOther"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>
              </>
            )}

            {(values.centerType === 'pediatric' ||
              values.centerType === 'whole_life') && (
              <>
                <div>
                  <label
                    htmlFor="numberOfPediatricSca"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Pediatric SCA Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfPediatricSca"
                    id="numberOfPediatricSca"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfPediatricSca"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>

                <div>
                  <label
                    htmlFor="numberOfPediatricSc"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Pediatric SC Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfPediatricSc"
                    id="numberOfPediatricSc"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfPediatricSc"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>

                <div>
                  <label
                    htmlFor="numberOfPediatricOther"
                    className="block text-sm font-medium text-[#3C2416] mb-2"
                  >
                    Other Pediatric Patients
                  </label>
                  <Field
                    type="number"
                    name="numberOfPediatricOther"
                    id="numberOfPediatricOther"
                    min="0"
                    className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                    placeholder="0"
                  />
                  <ErrorMessage
                    name="numberOfPediatricOther"
                    component="p"
                    className="mt-1 text-sm text-red-600"
                  />
                </div>
              </>
            )}

            <div>
              <label
                htmlFor="numberOfDedicatedOutpatientStaff"
                className="block text-sm font-medium text-[#3C2416] mb-2"
              >
                Dedicated Outpatient Staff *
              </label>
              <Field
                type="number"
                name="numberOfDedicatedOutpatientStaff"
                id="numberOfDedicatedOutpatientStaff"
                min="0"
                className="block w-full rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                placeholder="0"
              />
              <ErrorMessage
                name="numberOfDedicatedOutpatientStaff"
                component="p"
                className="mt-1 text-sm text-red-600"
              />
            </div>
          </div>
        </div>

        {/* Dedicated Clinic Space Section */}
        <div className="border-t border-gray-200 pt-6">
          <h4 className="text-lg font-semibold text-[#3C2416] mb-4">
            Dedicated Clinic Space
          </h4>
          <div className="space-y-4">
            <div className="flex items-center">
              <Field
                type="checkbox"
                name="dedicatedClinicSpace"
                id="dedicatedClinicSpace"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="dedicatedClinicSpace"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Does your center have dedicated clinic space?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="indepClinicSpace"
                id="indepClinicSpace"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="indepClinicSpace"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Is it an independent clinic space?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="dcsSharedWithCancerCenter"
                id="dcsSharedWithCancerCenter"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="dcsSharedWithCancerCenter"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Is dedicated clinic space shared with a cancer center?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="dcsSharedWithOther"
                id="dcsSharedWithOther"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="dcsSharedWithOther"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Is dedicated clinic space shared with something else?
              </label>
            </div>

            {values.dcsSharedWithOther && (
              <div className="ml-7">
                <label
                  htmlFor="dcsSharedWithOtherName"
                  className="block text-sm font-medium text-[#3C2416] mb-2"
                >
                  Please specify what the clinic space is shared with:
                </label>
                <Field
                  type="text"
                  name="dcsSharedWithOtherName"
                  id="dcsSharedWithOtherName"
                  className="block w-full max-w-md rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                  placeholder="Enter details"
                />
                <ErrorMessage
                  name="dcsSharedWithOtherName"
                  component="p"
                  className="mt-1 text-sm text-red-600"
                />
              </div>
            )}
          </div>
        </div>

        {/* Infusion Area Section */}
        <div className="border-t border-gray-200 pt-6">
          <h4 className="text-lg font-semibold text-[#3C2416] mb-4">
            Infusion Area
          </h4>
          <div className="space-y-4">
            <div className="flex items-center">
              <Field
                type="checkbox"
                name="infusionArea"
                id="infusionArea"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="infusionArea"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Does your center have an infusion area?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="infAreaDedicatedDayHospital"
                id="infAreaDedicatedDayHospital"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="infAreaDedicatedDayHospital"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Does the infusion area contain a dedicated day hospital?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="infAreaSharedWithCancerCenter"
                id="infAreaSharedWithCancerCenter"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="infAreaSharedWithCancerCenter"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Is the infusion area shared with a cancer center?
              </label>
            </div>

            <div className="flex items-center">
              <Field
                type="checkbox"
                name="infAreaSharedWithOther"
                id="infAreaSharedWithOther"
                className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
              />
              <label
                htmlFor="infAreaSharedWithOther"
                className="ml-3 text-sm font-medium text-[#3C2416]"
              >
                Is the infusion area shared with something else?
              </label>
            </div>

            {values.infAreaSharedWithOther && (
              <div className="ml-7">
                <label
                  htmlFor="infAreaSharedWithOtherName"
                  className="block text-sm font-medium text-[#3C2416] mb-2"
                >
                  Please specify what the infusion area is shared with:
                </label>
                <Field
                  type="text"
                  name="infAreaSharedWithOtherName"
                  id="infAreaSharedWithOtherName"
                  className="block w-full max-w-md rounded-lg border-0 py-3 px-4 text-[#142841] shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#A6410A] sm:text-sm sm:leading-6 transition-all duration-200"
                  placeholder="Enter details"
                />
                <ErrorMessage
                  name="infAreaSharedWithOtherName"
                  component="p"
                  className="mt-1 text-sm text-red-600"
                />
              </div>
            )}
          </div>
        </div>

        {/* Observation Unit */}
        <div className="border-t border-gray-200 pt-6">
          <h4 className="text-lg font-semibold text-[#3C2416] mb-4">
            Additional Facilities
          </h4>
          <div className="flex items-center">
            <Field
              type="checkbox"
              name="observationUnit"
              id="observationUnit"
              className="h-4 w-4 text-[#A6410A] focus:ring-[#A6410A] border-gray-300 rounded"
            />
            <label
              htmlFor="observationUnit"
              className="ml-3 text-sm font-medium text-[#3C2416]"
            >
              Does your center have an observation unit?
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
